import React, { useRef, useState } from 'react';
import Header from '../../components/ui/Header';
import Footer from '../homepage/components/Footer';
import Icon from '../../components/ui/Icon';

const DemoPage = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-grow container mx-auto px-4 pt-32 pb-12 flex flex-col items-center justify-center">
        <div className="max-w-7xl w-full space-y-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-foreground bg-clip-text text-transparent bg-gradient-to-r from-primary to-accent">
            OpenGadget Demo
          </h1>
          
          {/* Video Frame */}
          <div 
            className="relative rounded-2xl overflow-hidden shadow-floating border-4 border-muted p-1 bg-card group cursor-pointer" 
            onClick={handlePlay}
          >
            <div className="aspect-video bg-black rounded-xl overflow-hidden relative">
                <video 
                  ref={videoRef}
                  className="w-full h-full object-cover"
                  controls={isPlaying}
                  src="/assets/images/OpenGadget.mp4"
                  onPlay={() => setIsPlaying(true)}
                  onPause={() => setIsPlaying(false)}
                  onEnded={() => setIsPlaying(false)}
                >
                  Your browser does not support the video tag.
                </video>
                
                {/* Custom Play Button Overlay */}
                {!isPlaying && (
                  <div className="absolute inset-0 flex items-center justify-center bg-black/40 group-hover:bg-black/30 transition-all">
                    <div className="w-24 h-24 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center border-2 border-white/50 shadow-lg group-hover:scale-110 transition-transform duration-300">
                        <Icon name="Play" size={48} className="text-white ml-2 fill-current" />
                    </div>
                  </div>
                )}
            </div>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <p className="text-xl text-muted-foreground font-medium">
              Discover how easy OpenGadget streamlines your replacement workflow in 3D. Sourcing is a breeze.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DemoPage;